var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrLeftWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Chevron_Right",
    d: "M0.206524 8.03535L6.56094 14.7786C6.83977 15.0738 7.29152 15.0738 7.57105 14.7786C7.84988 14.4833 7.84988 14.0038 7.57105 13.7085L1.72066 7.50037L7.57034 1.2922C7.84917 0.99696 7.84917 0.517415 7.57034 0.221429C7.29152 -0.0738097 6.83907 -0.0738097 6.56024 0.221429L0.20582 6.96458C-0.068724 7.25677 -0.068724 7.74385 0.206524 8.03535Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrLeftWhite);
export default __webpack_public_path__ + "static/media/arr-left-white.800f3daa1f9e233e11c6bd6802e976ab.svg";
export { ForwardRef as ReactComponent };